<script setup lang="ts">
import { NxtInput, NxtDropdown } from '@future-harry/nxt-styles';
import { JobBoard } from '@/core/collections/job-boards/job-board.interface';
import { useSettingsStore } from '@/apps/admin/stores/settings.store';

const jobBoard = defineModel<JobBoard>('modelValue', { required: true });

const settingsStore = useSettingsStore();
const jobBoardSettingsErrors = computed(() => settingsStore.validationErrors.value);

const FONT_FAMILIES = [
   { id: 'Arial', name: 'Arial' },
   { id: 'Courier New', name: 'Courier New' },
   { id: 'Georgia', name: 'Georgia' },
   { id: 'Times New Roman', name: 'Times New Roman' },
   { id: 'Verdana', name: 'Verdana' },
];
</script>

<template>
   <section>
      <div class="row">
         <div class="col-half">
            <NxtDropdown
               :name="`settings_font_family`"
               :label="$t('job-board.settings.theme.font_family')"
               v-model="jobBoard.font_family"
               :options="FONT_FAMILIES"
            />
            <NxtInput
               :type="'color'"
               :name="`settings_primary_color`"
               :label="$t('job-board.settings.theme.primary_color')"
               :description="$t('job-board.settings.theme.primary_color_description')"
               v-model="jobBoard.primary_color"
            />
            <NxtInput
               :type="'color'"
               :name="`settings_primary_color`"
               :label="$t('job-board.settings.theme.primary_font_color')"
               :description="$t('job-board.settings.theme.primary_font_color_description')"
               v-model="jobBoard.primary_font_color"
            />
            <NxtInput
               :type="'color'"
               :name="`settings_primary_color`"
               :label="$t('job-board.settings.theme.secondary_font_color')"
               :description="$t('job-board.settings.theme.secondary_font_color_description')"
               v-model="jobBoard.secondary_font_color"
            />
            <div class="row">
               <div class="col-half">
                  <NxtInput
                     v-model="jobBoard.border_radius"
                     :name="`border_radius`"
                     :label="$t('job-board.settings.theme.border_radius')"
                     :placeholder="'5'"
                     :errors="jobBoardSettingsErrors"
                     class="border-radius-input"
                  />
               </div>
               <div class="col-half"><span class="center-text">px</span></div>
            </div>
         </div>
         <div class="col-half"></div>
      </div>
   </section>
</template>
